/* DNA Auto — Everyday Essentials: 3D coverflow for the category carousel (Oct 27 2026).
   Native scroll-snap does the swiping (fast, no JS scrolling); on every scroll frame each card gets --d (signed distance
   from the viewport centre, -1..1) and --a (|d|) and CSS turns that into rotateY / scale / depth / fade. One rAF per
   scroll, transforms only, passive listeners — nothing that can jank. Arrow keys and the dots work too. */
(function () {
  function setup(root) {
    var track = root.querySelector('.ev-cf__track'); if (!track) return;
    var items = Array.prototype.slice.call(track.querySelectorAll('.ev-cf__item'));
    var cards = items.map(function (li) { return li.querySelector('.ev-cf__card'); });
    var dots = root.querySelector('.ev-cf__dots'), dotEls = [];
    if (dots) { items.forEach(function (_, i) { var d = document.createElement('i'); dots.appendChild(d); dotEls.push(d); }); }
    var ticking = false, cur = -1;
    function paint() {
      ticking = false;
      var r = track.getBoundingClientRect(), mid = r.left + r.width / 2, span = r.width * 0.55, best = 0, bestA = 9;
      for (var i = 0; i < items.length; i++) {
        var b = items[i].getBoundingClientRect(), c = b.left + b.width / 2, d = (c - mid) / span;
        if (d > 1) d = 1; if (d < -1) d = -1;
        var a = d < 0 ? -d : d;
        cards[i].style.setProperty('--d', d.toFixed(3)); cards[i].style.setProperty('--a', a.toFixed(3));
        if (a < bestA) { bestA = a; best = i; }
      }
      if (best !== cur) { cur = best; dotEls.forEach(function (d, i) { d.classList.toggle('is-on', i === best); }); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    function centre(i, smooth) {   // horizontal only — never scrolls the page itself
      var li = items[i]; if (!li) return;
      var x = li.offsetLeft - (track.clientWidth - li.offsetWidth) / 2;
      if (smooth && 'scrollTo' in track) track.scrollTo({ left: x, behavior: 'smooth' }); else track.scrollLeft = x;
    }
    dotEls.forEach(function (d, i) { d.addEventListener('click', function () { centre(i, true); }); });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { centre(Math.max(0, Math.min(items.length - 1, cur + (e.key === 'ArrowRight' ? 1 : -1))), true); e.preventDefault(); } });
    root.setAttribute('tabindex', '0');
    centre(0, false);   // start centred on the first card
    paint();
    if ('ResizeObserver' in window) new ResizeObserver(onScroll).observe(track);
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ev-cf]'), function (r) { if (!r.__evcf) { r.__evcf = true; setup(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('dna:navigate', init);   // re-init after an in-place page swap
  document.addEventListener('shopify:section:load', init);
})();
